import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import './style.css';
import { Provider } from 'jotai';
import { atomStore } from './services/sync.service';

const rootElement = document.getElementById('root');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <Provider store={atomStore}>
                <App />
            </Provider>
        </React.StrictMode>
    );
}